/**
 * CoLab Services Slider Module
 * Expandable слайдер послуг з табами та touch swipe
 */

export const Services = {
    slider: null,
    slides: null,
    prevBtn: null,
    nextBtn: null,
    tabs: null,
    activeIndex: 0,
    filteredSlides: [],

    // Touch swipe config
    touch: {
        startX: 0,
        startY: 0,
        startTime: 0,
        threshold: 50,
        restraint: 100,
        allowedTime: 500
    },

    // Категорії для слайдів (налаштуй під свої потреби)
    slideCategories: {
        0: 'all',
        1: 'cosmetics',
        2: 'medical'
    },

    init: function() {
        this.slider = document.querySelector('.services__slider');
        this.slides = document.querySelectorAll('.services__slide');
        this.prevBtn = document.querySelector('.services__nav-btn--prev');
        this.nextBtn = document.querySelector('.services__nav-btn--next');
        this.tabs = document.querySelectorAll('.services__tab');

        if (!this.slides.length) return;

        this.filteredSlides = Array.from(this.slides);
        this.bindEvents();
        this.bindTouchEvents();
        this.setActiveSlide(0, false);

        console.log('[CoLab.Services] Initialized');
    },

    bindEvents: function() {
        var self = this;

        // Click on slide to expand
        this.slides.forEach(function(slide, index) {
            slide.addEventListener('click', function() {
                if (!slide.classList.contains('is-active') && !slide.classList.contains('is-hidden')) {
                    var filteredIndex = self.filteredSlides.indexOf(slide);
                    if (filteredIndex !== -1) {
                        self.setActiveSlide(filteredIndex);
                    }
                }
            });
        });

        // Navigation buttons
        if (this.prevBtn) {
            this.prevBtn.addEventListener('click', function() {
                self.prev();
            });
        }

        if (this.nextBtn) {
            this.nextBtn.addEventListener('click', function() {
                self.next();
            });
        }

        // Tabs - клік на таб переключає на відповідний слайд
        this.tabs.forEach(function(tab, tabIndex) {
            tab.addEventListener('click', function() {
                self.activateTab(tab, tabIndex);
            });
        });

        // Keyboard navigation
        if (this.slider) {
            this.slider.setAttribute('tabindex', '0');
            this.slider.addEventListener('keydown', function(e) {
                if (e.key === 'ArrowLeft') {
                    e.preventDefault();
                    self.prev();
                } else if (e.key === 'ArrowRight') {
                    e.preventDefault();
                    self.next();
                }
            });
        }
    },

    // ============================================
    // Touch Swipe
    // ============================================
    bindTouchEvents: function() {
        var self = this;

        if (!this.slider) return;

        this.slider.addEventListener('touchstart', function(e) {
            var touch = e.changedTouches[0];
            self.touch.startX = touch.pageX;
            self.touch.startY = touch.pageY;
            self.touch.startTime = Date.now();
        }, { passive: true });

        this.slider.addEventListener('touchmove', function(e) {
            if (!self.touch.startX) return;

            var touch = e.changedTouches[0];
            var deltaX = touch.pageX - self.touch.startX;
            var deltaY = touch.pageY - self.touch.startY;

            // Блокуємо вертикальний скрол при горизонтальному свайпі
            if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 10) {
                e.preventDefault();
            }
        }, { passive: false });

        this.slider.addEventListener('touchend', function(e) {
            var touch = e.changedTouches[0];
            var deltaX = touch.pageX - self.touch.startX;
            var deltaY = touch.pageY - self.touch.startY;
            var elapsedTime = Date.now() - self.touch.startTime;

            // Перевіряємо умови свайпу
            if (elapsedTime <= self.touch.allowedTime &&
                Math.abs(deltaX) >= self.touch.threshold &&
                Math.abs(deltaY) <= self.touch.restraint) {

                if (deltaX < 0) {
                    self.next();
                } else {
                    self.prev();
                }
            }

            self.touch.startX = 0;
            self.touch.startY = 0;
        }, { passive: true });
    },

    // ============================================
    // Slide Management
    // ============================================
    setActiveSlide: function(index, animate) {
        var self = this;
        animate = animate !== false;

        // Валідація
        if (index < 0 || index >= this.filteredSlides.length) return;

        // Remove active class from all
        this.slides.forEach(function(slide) {
            slide.classList.remove('is-active');
            if (animate) {
                slide.classList.add('is-transitioning');
            }
        });

        // Add active class
        requestAnimationFrame(function() {
            self.filteredSlides.forEach(function(slide, i) {
                if (i === index) {
                    slide.classList.add('is-active');
                }
            });

            self.activeIndex = index;
            self.updateNavButtons();
            self.updateTabs();

            // Remove transitioning class after animation
            setTimeout(function() {
                self.slides.forEach(function(slide) {
                    slide.classList.remove('is-transitioning');
                });
            }, 800);
        });
    },

    updateNavButtons: function() {
        if (this.prevBtn) {
            this.prevBtn.disabled = this.activeIndex === 0;
        }
        if (this.nextBtn) {
            this.nextBtn.disabled = this.activeIndex === this.filteredSlides.length - 1;
        }
    },

    // Синхронізація табів з активним слайдом
    updateTabs: function() {
        var self = this;

        this.tabs.forEach(function(tab, tabIndex) {
            if (tabIndex === self.activeIndex) {
                tab.classList.add('is-active');
            } else {
                tab.classList.remove('is-active');
            }
        });
    },

    next: function() {
        if (this.activeIndex < this.filteredSlides.length - 1) {
            this.setActiveSlide(this.activeIndex + 1);
        }
    },

    prev: function() {
        if (this.activeIndex > 0) {
            this.setActiveSlide(this.activeIndex - 1);
        }
    },

    // ============================================
    // Tabs
    // ============================================
    activateTab: function(tab, tabIndex) {
        var self = this;

        // Update tab states
        this.tabs.forEach(function(t) {
            t.classList.remove('is-active');
        });
        tab.classList.add('is-active');

        // Show all slides and activate by tab index
        this.slides.forEach(function(slide) {
            slide.classList.remove('is-hidden');
        });
        this.filteredSlides = Array.from(this.slides);

        if (tabIndex < this.slides.length) {
            this.setActiveSlide(tabIndex);
        }
    },

    filterSlides: function(filter) {
        var self = this;

        if (filter === 'all') {
            this.filteredSlides = Array.from(this.slides);
            this.slides.forEach(function(slide) {
                slide.classList.remove('is-hidden');
            });
        } else {
            this.filteredSlides = [];
            this.slides.forEach(function(slide, index) {
                var category = self.slideCategories[index];
                if (category === filter || category === 'all') {
                    slide.classList.remove('is-hidden');
                    self.filteredSlides.push(slide);
                } else {
                    slide.classList.add('is-hidden');
                }
            });
        }

        if (this.filteredSlides.length > 0) {
            this.setActiveSlide(0);
        }
    }
};
